module.exports = __webpack_public_path__ + "img/woman-at-cel.56d87a3b.webp";